module.exports = __webpack_public_path__ + "static/media/email.bee32f5e.svg";